import "./link-grid-item.scss";

function LinkGridItem(props) {
    const url = props.url;
    const text = props.text;
    const target = props.target;
    const image = props.image;

    return (
        <a href={url} target={target} className="link-grid-item">
            <div className="row">
                <div className="col text-center">
                    <img src={image} className="app-icon"></img>
                </div>
            </div>
            <div className="row">
                <div className="col text-center">{text}</div>
            </div>
        </a>
    );
}

export default LinkGridItem;
